/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AIAnnotationCreateRequest
 */
export interface AIAnnotationCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof AIAnnotationCreateRequest
     */
    proxy: number;
    /**
     * 
     * @type {string}
     * @memberof AIAnnotationCreateRequest
     */
    category: string;
    /**
     * 
     * @type {number}
     * @memberof AIAnnotationCreateRequest
     */
    frame: number;
    /**
     * 
     * @type {number}
     * @memberof AIAnnotationCreateRequest
     */
    relativeLeft: number;
    /**
     * 
     * @type {number}
     * @memberof AIAnnotationCreateRequest
     */
    relativeTop: number;
    /**
     * 
     * @type {number}
     * @memberof AIAnnotationCreateRequest
     */
    relativeWidth: number;
    /**
     * 
     * @type {number}
     * @memberof AIAnnotationCreateRequest
     */
    relativeHeight: number;
}

export function AIAnnotationCreateRequestFromJSON(json: any): AIAnnotationCreateRequest {
    return AIAnnotationCreateRequestFromJSONTyped(json, false);
}

export function AIAnnotationCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIAnnotationCreateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'proxy': json['proxy'],
        'category': json['category'],
        'frame': json['frame'],
        'relativeLeft': json['relative_left'],
        'relativeTop': json['relative_top'],
        'relativeWidth': json['relative_width'],
        'relativeHeight': json['relative_height'],
    };
}

export function AIAnnotationCreateRequestToJSON(value?: AIAnnotationCreateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'proxy': value.proxy,
        'category': value.category,
        'frame': value.frame,
        'relative_left': value.relativeLeft,
        'relative_top': value.relativeTop,
        'relative_width': value.relativeWidth,
        'relative_height': value.relativeHeight,
    };
}


